import {ApiBaseService} from "@portal/api/api-base-service";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {ApiResponse, ListResponse} from "@portal/api/responses/api-response";
import {CreatePartyLocationRequest} from "@portal/api/requests/party-locations/create-party-location-request";
import {UpdatePartyLocationRequest} from "@portal/api/requests/party-locations/update-party-location-request";
import {SearchRequest} from "@portal/api/requests/search-request";
import {Guid} from "guid-typescript";
import {PartyLocationResponse} from "@portal/api/responses/party-locations/party-location-response";
import {Injectable} from "@angular/core";
import {StorageService} from "@portal/shared/services/storage.service";
import {OrganizationType} from "@portal/api/enums/organization-type";

@Injectable({
    providedIn: 'root',
})
export class PartyLocationsService extends ApiBaseService {
    controller = 'v1/partylocations';

    constructor(
        public http: HttpClient,
        private _storageService: StorageService,
    ) {
        super(http);
    }

    private get isOrgScope(): boolean {
        return this._storageService.getOrg()?.type === OrganizationType.Association;
    }

    add(obj: CreatePartyLocationRequest): Observable<ApiResponse<string>> {
        const orgId = this._storageService.getOrg()?.id;
        const partyId = this._storageService.getParty()?.id;
        if (this.isOrgScope || !partyId) {
            return this.post<ApiResponse<string>, CreatePartyLocationRequest>(obj, `v1/orgs/${orgId}/donations/locations/add`);
        }
        return this.post<ApiResponse<string>, CreatePartyLocationRequest>(obj, `v1/orgs/${orgId}/parties/${partyId}/donations/locations/add`);
    }

    update(obj: UpdatePartyLocationRequest) {
        const orgId = this._storageService.getOrg()?.id;
        const partyId = this._storageService.getParty()?.id;
        if (this.isOrgScope || !partyId) {
            return this.put<ApiResponse<string>, UpdatePartyLocationRequest>(obj, `v1/orgs/${orgId}/donations/locations/update`);
        }
        return this.put<ApiResponse<string>, UpdatePartyLocationRequest>(obj, `v1/orgs/${orgId}/parties/${partyId}/donations/locations/update`);
    }

    getFormEdit(id: string): Observable<ApiResponse<UpdatePartyLocationRequest>> {
        const orgId = this._storageService.getOrg()?.id;
        const partyId = this._storageService.getParty()?.id;
        if (this.isOrgScope || !partyId) {
            return this.get<ApiResponse<UpdatePartyLocationRequest>>(`v1/orgs/${orgId}/donations/locations/form/edit/${id}`);
        }
        return this.get<ApiResponse<UpdatePartyLocationRequest>>(`v1/orgs/${orgId}/parties/${partyId}/donations/locations/form/edit/${id}`);
    }

    listByParty(obj: SearchRequest): Observable<ApiResponse<ListResponse<PartyLocationResponse[]>>> {
        const orgId = this._storageService.getOrg()?.id;
        const partyId = this._storageService.getParty()?.id;
        if (this.isOrgScope || !partyId) {
            return this.post<ApiResponse<ListResponse<PartyLocationResponse[]>>, SearchRequest>(obj, `v1/orgs/${orgId}/donations/locations/listall`);
        }
        return this.post<ApiResponse<ListResponse<PartyLocationResponse[]>>, SearchRequest>(obj, `v1/orgs/${orgId}/parties/${partyId}/donations/locations/listall`);
    }

    deleteLocation(id: Guid): Observable<ApiResponse<boolean>> {
        const orgId = this._storageService.getOrg()?.id;
        const partyId = this._storageService.getParty()?.id;
        if (this.isOrgScope || !partyId) {
            return this.deleteBase<ApiResponse<boolean>>(`v1/orgs/${orgId}/donations/locations/${id}`);
        }
        return this.deleteBase<ApiResponse<boolean>>(`v1/orgs/${orgId}/parties/${partyId}/donations/locations/${id}`);
    }

    reorder(ids: string[]): Observable<ApiResponse<boolean>> {
        const orgId = this._storageService.getOrg()?.id;
        const partyId = this._storageService.getParty()?.id;
        if (this.isOrgScope || !partyId) {
            return this.put<ApiResponse<boolean>, { ids: string[] }>({ ids }, `v1/orgs/${orgId}/donations/locations/reorder`);
        }
        return this.put<ApiResponse<boolean>, { ids: string[] }>({ ids }, `v1/orgs/${orgId}/parties/${partyId}/donations/locations/reorder`);
    }
}
